import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import {
  Table, Text, TouchableOpacity, View,
} from '../../../app-components';
import { listUri } from '../../../Queries/avrules';
import { ROUTES } from '../../../Lib/constants';
import vars from '../../../theme/vars';
import { shorten } from '../../../Lib/helpers';
import { invoke } from '../../../AppServices';

const { headings } = vars;

const ViewButton = () => {
  const [h, setH] = useState(false);

  return (
    <TouchableOpacity>
      <View
        onMouseOver={() => setH(true)}
        onFocus={() => setH(true)}
        onMouseLeave={() => setH(false)}
        style={{
          width: 110,
          borderRadius: 15,
          backgroundColor: h ? 'rgb(118,215,196)' : 'rgb(72,201,176)',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
      >
        <Text style={{ ...headings.h8, color: '#FFF' }}>View</Text>
      </View>
    </TouchableOpacity>
  );
};

const StatusButton = ({ item, navigation }) => {
  const [h, setH] = useState(false);

  const decideColor = () => {
    if (item?.rulestatus === 'Active') {
      return h ? 'rgb(118,215,196)' : 'rgb(72,201,176)';
    }
    return h ? 'rgb( 248, 196, 113 )' : 'rgb( 245, 176, 65 )';
  };

  const bgColor = decideColor();

  return (
    <>
      <ReactTooltip place="bottom" type="dark" effect="float" id={item._id} />
      <div data-tip="Toggle Status" data-for={item._id}>
        <TouchableOpacity
          onMouseOver={() => setH(true)}
          onFocus={() => setH(true)}
          onMouseLeave={() => setH(false)}
          style={{
            width: 120,
            borderRadius: 15,
            backgroundColor: bgColor,
            alignItems: 'center',
            paddingTop: 5,
            paddingBottom: 5,
          }}
          onPress={async () => {
            const routeName = navigation?.state?.routeName;
            const { _id, rulestatus } = item;

            await invoke({
              id: 'ruleStatusToggle',
              paramValue: {
                data: { _id, rulestatus },
              },
            });
            navigation.reset(routeName);
          }}
        >
          <Text style={{ ...headings.h8, color: 'white' }}>
            {item?.rulestatus}
          </Text>
        </TouchableOpacity>
      </div>
    </>
  );
};

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Rule #',
        width: 200,
        render: ({ index }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {index + 1}
          </Text>
        ),
      },

      {
        header: 'Name',
        width: 200,
        render: ({ item = {} }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {shorten(item?.rulename, 18)}
          </Text>
        ),
      },
      {
        header: 'Status',
        width: 200,
        render: ({ item, navigation }) => (
          <StatusButton item={item} navigation={navigation} />
        ),
      },

      {
        header: 'Dealer',
        width: 200,
        render: ({ item = {} }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {shorten(item?.madeByName, 18)}
          </Text>
        ),
      },
      {
        header: 'Mileage',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {item?.mileageType === 'All'
              ? 'All'
              : `${item?.minMileage} - ${item?.maxMileage}`}
          </Text>
        ),
      },
      {
        header: 'Enhancement',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {`${item?.ruleEnhancement} %`}
          </Text>
        ),
      },
      {
        header: 'Spread',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {item?.ruleSpread ? `${item?.ruleSpread} %` : '--'}
          </Text>
        ),
      },

      {
        header: 'Year(s)',
        width: 200,
        render: ({ item }) => (
          <Text style={{ ...headings.h8, color: '#333' }}>
            {item.carDetails === 'Any'
              ? 'Any'
              : `${item?.fromYear} - ${item?.toYear}`}
          </Text>
        ),
      },

      {
        header: 'Make',
        width: 200,
        render: () => <ViewButton />,
        action: ({ item }) => ({
          type: 'link',
          link: {
            view: ROUTES.makeList.name,
            params: { title: 'Make(s)', item },
          },
        }),
      },
      {
        header: 'Model',
        width: 200,
        render: () => <ViewButton />,
        action: ({ item }) => ({
          type: 'link',
          link: {
            view: ROUTES.makeModelList.name,
            params: { title: 'Model(s)', item, ruleId: item._id },
          },
        }),
      },
    ],
  },
};

export default Table({
  reloadEvent: 'AVRulesListReload',
  uri: listUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.avRulesView.name,
      params: { item: { ...item }, editable: false },
    },
  }),
});
